import styled from "styled-components"
import {Alert} from "antd";

export const StyledAlert = styled(Alert)`

  .ant-alert-icon{
    svg{
      width: 24px;
    }
  }
`